import script from "./Recaptcha.vue?vue&type=script&setup=true&lang=js"
export * from "./Recaptcha.vue?vue&type=script&setup=true&lang=js"

import "./Recaptcha.vue?vue&type=style&index=0&id=5a4f5a00&lang=scss"

const __exports__ = script;

export default __exports__